import { useEffect } from "react";
import { ArrowRight, Bookmark, Link2 } from "lucide-react";

import styles from "./migration-page.module.css";

const NEW_DOMAIN = "https://one.caeliusconsulting.com/";

export default function MigrationPage() {
  useEffect(() => {
    const previousTitle = document.title;
    document.title = "CaeliusOne Has Moved";
    return () => { document.title = previousTitle; };
  }, []);

  return <main className={styles.page}>
    <span className={`${styles.decorativeRing} ${styles.ringTop}`} aria-hidden="true" />
    <span className={`${styles.decorativeRing} ${styles.ringBottom}`} aria-hidden="true" />

    <div className={styles.branding}>
      <img className={styles.consultingLogo} src="/assets/caelius-logo.svg" alt="Caelius Consulting" />
      <span className={styles.brandDivider} aria-hidden="true" />
      <img className={styles.oneLogo} src="/assets/CaeliusOne_wordmark.svg" alt="CaeliusOne" />
    </div>

    <section className={styles.card}>
      <div className={styles.migrationVisualFrame}>
        <img
          className={styles.migrationVisual}
          src="/assets/caelius-migration-success.jpg"
          alt="Namecheap hosting migrated successfully to AWS infrastructure"
        />
      </div>

      <h1>Thank you for your patience.</h1>
      <p>CaeliusOne is now available on a new domain with major performance updates, offering a faster, more reliable experience.</p>

      <a className={styles.primaryAction} href={NEW_DOMAIN}>
        Go to CaeliusOne <ArrowRight />
      </a>

      <a className={styles.domainLink} href={NEW_DOMAIN}>
        <Link2 /> <span>one.caeliusconsulting.com</span>
      </a>

      <p className={styles.bookmark}><Bookmark /> Please bookmark the new URL for future access.</p>
    </section>

    <footer>&copy; 2026 Caelius Consulting. All rights reserved.</footer>
  </main>;
}
